import React, {useState} from 'react';
import {Alert, Divider, Stack, Typography} from '@mui/material';
import {NciTree} from './NciTree';
import {NciTable} from './NciTable';
import {useQuery} from '@tanstack/react-query';
import {NciAdministrationService} from '@services/NciAdministration/NciAdministrationService';
import {NciDict} from './types';
import {useTranslation} from 'react-i18next';

export const NciAdministration = () => {
    const {t} = useTranslation(['administration', 'common']);
    const service = NciAdministrationService;
    const [selectedDict, setSelectedDict] = useState<NciDict | null>(null);

    const {data: nciGroups} = useQuery({
        queryKey: ['NciGroups'],
        queryFn: () => service.getNciGroupsTree(),
    });

    if (!nciGroups) {
        return <div>{t('noData')}</div>;
    }

    return (
        <Stack direction='row'>
            <NciTree
                tree={nciGroups}
                selectedDict={selectedDict}
                setSelectedDict={setSelectedDict}
            />
            <Divider
                orientation='vertical'
                flexItem
            />
            <Stack
                ml={3}
                direction='column'
                width='100%'
                gap={1}
            >
                <Typography variant='h6'>{selectedDict?.dictName ?? t('mtrNames')}</Typography>
                {!selectedDict && (
                    <Stack>
                        <Alert severity='info'>{t('chooseNciGroup')}</Alert>
                    </Stack>
                )}
                {selectedDict && <NciTable selectedDict={selectedDict} />}
            </Stack>
        </Stack>
    );
};
